import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-search-by-id-modal',
  templateUrl: './search-by-id-modal.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    RouterModule,
  ],
})
export class SearchByIdModalComponent implements OnInit {
  public error = '';
  public value = '';

  constructor(
    public router: Router,
    private dialogRef: MatDialogRef<SearchByIdModalComponent>,
  ) {}

  ngOnInit(): void {}

  submit() {
    this.dialogRef.close();
    this.router.navigate(['/search-by-id', this.value]);
  }
}
